import "./App.css";
import "./normalize.css";
import React, { useState } from "react";
import {HashRouter} from "react-router-dom";
import Main from "./components/main/Main.component";
import FixelDataContext from "./context/FixelDataContext";
import {CustomerProvider} from "./provider/customerProvider";
import {loadStripe} from "@stripe/stripe-js/pure";
import {Elements} from "@stripe/react-stripe-js";
import styled from "styled-components";
import FixelLoaderModal from "./components/commons/Loader/FixelLoaderModal";
import {ModalProvider,BaseModalBackground} from "styled-react-modal";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
const FadingBackground = styled(BaseModalBackground)`
  opacity: ${(props) => props.opacity};
  transition: all 1s ease-in-out;
`;

function App() {
  const [fullFixelData, setFullFixelData] = useState({});
  const [showSpinner, setShowSpinner] = useState(false);

    return (
        <Elements stripe={stripePromise}>
          <div className="App">
              <ModalProvider backgroundComponent={FadingBackground}>
                <FixelDataContext.Provider value={{ fullFixelData, setFullFixelData, showSpinner, setShowSpinner }}>
                    <CustomerProvider>
                      <HashRouter>
                        <FixelLoaderModal show={showSpinner} />
                        <Main />
                      </HashRouter>
                    </CustomerProvider>
                </FixelDataContext.Provider>
              </ModalProvider>
          </div>
        </Elements>
  );
}

export default App;
